import { useState, useEffect } from "react";

const ArticleTranslateWidget = () => {
  const [currentLang, setCurrentLang] = useState(
    () => localStorage.getItem("site_lang") || "en"
  );

  useEffect(() => {
    const saved = localStorage.getItem("site_lang") || "en";
    setCurrentLang(saved);
  }, []);

  const switchLanguage = (lang) => {
    const hostname = window.location.hostname;
    const parts = hostname.split(".");
    const rootDomain = parts.length > 1 ? "." + parts.slice(-2).join(".") : hostname;

    const setCookie = (name, value) => {
      document.cookie = `${name}=${value}; path=/;`;
      document.cookie = `${name}=${value}; path=/; domain=${hostname};`;
      if (rootDomain !== hostname) {
        document.cookie = `${name}=${value}; path=/; domain=${rootDomain};`;
      }
    };

    setCookie("googtrans", `/auto/${lang}`);
    sessionStorage.setItem("site_lang", lang);
    localStorage.setItem("site_lang", lang);
    setCurrentLang(lang);

    const select = document.querySelector(".goog-te-combo");
    if (select) {
      select.value = lang;
      select.dispatchEvent(new Event("change"));
    } else {
      window.location.reload();
    }
  };

  return (
    <div
      className="article-translate-widget"
      style={{
        border: "1px solid rgba(0, 0, 0, 0.08)",
        borderRadius: 14,
        padding: "16px 18px",
        background: "#fdfdfd",
        marginTop: 24,
        marginBottom: 24,
      }}
    >
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          gap: 12,
          alignItems: "center",
          flexWrap: "wrap",
        }}
      >
        <div>
          <h4 style={{ margin: 0, fontSize: "1.05rem", fontWeight: 600 }}>
            <i className="fa fa-language me-2" style={{ color: "#d90429" }}></i>
            Translate this article
          </h4>
          <p style={{ margin: "4px 0 0", color: "#666", fontSize: "0.88rem" }}>
            Translate title and content to Arabic, English, or French:
          </p>
        </div>
        <div style={{ display: "flex", gap: 8, alignItems: "center", flexWrap: "wrap" }}>
          <button
            type="button"
            onClick={() => switchLanguage("ar")}
            className="btn btn-sm"
            style={{
              padding: "6px 14px",
              borderRadius: "20px",
              fontSize: "0.85rem",
              fontWeight: 600,
              backgroundColor: currentLang === "ar" ? "#d90429" : "#f1f3f5",
              color: currentLang === "ar" ? "#fff" : "#333",
              border: "1px solid rgba(0,0,0,0.1)",
              cursor: "pointer",
            }}
          >
            العربية (Arabic)
          </button>
          <button
            type="button"
            onClick={() => switchLanguage("en")}
            className="btn btn-sm"
            style={{
              padding: "6px 14px",
              borderRadius: "20px",
              fontSize: "0.85rem",
              fontWeight: 600,
              backgroundColor: currentLang === "en" ? "#d90429" : "#f1f3f5",
              color: currentLang === "en" ? "#fff" : "#333",
              border: "1px solid rgba(0,0,0,0.1)",
              cursor: "pointer",
            }}
          >
            English
          </button>
          <button
            type="button"
            onClick={() => switchLanguage("fr")}
            className="btn btn-sm"
            style={{
              padding: "6px 14px",
              borderRadius: "20px",
              fontSize: "0.85rem",
              fontWeight: 600,
              backgroundColor: currentLang === "fr" ? "#d90429" : "#f1f3f5",
              color: currentLang === "fr" ? "#fff" : "#333",
              border: "1px solid rgba(0,0,0,0.1)",
              cursor: "pointer",
            }}
          >
            Français
          </button>
        </div>
      </div>
    </div>
  );
};

export default ArticleTranslateWidget;
